import type { FC } from 'react';
import { useLocation } from 'react-router-dom';
import type { ActiveSection } from 'src/components/layout/header/types';
import { Link } from 'src/components/navigation/link';
import { useBreakpoints } from 'src/hooks/use-breakpoints';

export const isGdmActive = (pathname: string) => pathname.startsWith('/gdm');

export const SecondaryNavGdm: FC<{ activeSection: ActiveSection }> = ({
  activeSection,
}) => {
  const { pathname } = useLocation();
  const { minTablet } = useBreakpoints();

  if (!activeSection.gdm) return null;

  const isActiveVerificationsLink =
    pathname.startsWith('/gdm/ts-verification') ||
    pathname.startsWith('/gdm/ts-completeness-check-violation');

  return (
    <div
      className={`
        flex flex-col flex-wrap items-stretch gap-x-xl gap-y-md
        md:flex-row md:items-center
        legacy:gap-x-[2rem] legacy:gap-y-[1rem]
      `}
      data-testid="secondary-nav"
    >
      <Link data-testid="time-series" mode="secondary" to="/gdm/ts-master">
        Time Series
      </Link>

      <Link
        data-testid="verifications"
        mode="secondary"
        to="/gdm/ts-verification"
        isActive={isActiveVerificationsLink}
      >
        Verifications
      </Link>

      <Link data-testid="reports" mode="secondary" to="/gdm/ts-report">
        Reports
      </Link>
    </div>
  );
};
